import Axios2 from "@/utils/Axios2";

/**
 * 获取误报源设备开机记录列表
 */
export function getMisReport(context) {
  let param = {};
  param.method = "post";
  param.url = "api/v1/risk/misreport/device/list";
  param.data = {
    branchId: context.savebranchId,
  }
  return Axios2.ajax(param).then((res) => {
    if (res.data && res.data.length > 0) {
      context.misreportList = res.data;
      context.helpDevice = res.data.length || 0;
      context.ismisreport = true;
    } else {
      context.ismisreport = false;
    }
  }).catch(() => {
    context.ismisreport = false;
  });
}

/**
 * 获取误报源类型统计误报源设备数量
 */
export function getMisReportType(context) {
  let param = {};
  param.method = "get";
  param.url = "api/v1/risk/misreport/device/statisticByMisType";
  param.params  = {
    branchId: context.savebranchId,
  }
  return Axios2.ajax(param).then((res) => {
    if (res.data) {
      context.misreportType = Object.values(res.data.typeCountMap).filter(value => value !== 0).length;
    }
  }).catch(() => {
    context.$message.error('获取类型统计失败');
  })
}
/**
 * 获取误报源隐患设备详情
 */
export function getMisReportDetail(context, row) {
  let param = {};
  param.method = "get";
  param.url = "/api/v1/risk/misreport/device/record/list";
  param.params = {
    deviceId: row.id,
  }
  return Axios2.ajax(param).then((res) => {
    if (res.data) {
      context.misreportDetailList = res.data.dataList;
      context.showMisreportDetail = true;
    }
  }).catch(() => {
    context.$message.error('获取详情失败');
  });
}

/**
 * 保存误报源定位备注
 */
export function saveRemarkMisreport(context, row) {
  if (!row.comment) {
    context.$message.warning('请输入备注内容');
    return Promise.reject('请输入备注内容');
  }

  let param = {};
  param.method = "get";
  param.url = "/api/v1/risk/misreport/device/comment/update";
  param.params = {
    deviceId: row.id,
    comment: row.comment,
  }

  return Axios2.ajax(param).then((res) => {
    if (res.code === 0) {
      context.$message.success('备注保存成功');
    } else {
      context.$message.error(res.msg || '保存失败');
      return Promise.reject(res.msg || '保存失败');
    }
  }).catch(() => {
    context.$message.error('保存失败');
    return Promise.reject('保存失败');
  });
}

/**
 * 返回误报源设备列表
 */
export function returnMisreportToList(context) {
  context.showMisreportDetail = false;
  context.misreportDetailList = [];
}
